/** Trim and remove spaces; lowercase for API. */
export function normalizeEmail(email) {
	if (email == null) return "";
	return String(email).trim().replace(/\s+/g, "").toLowerCase();
}

/** Local part may be digits-only (e.g. 123456@gmail.com). */
export function isValidEmail(email) {
	const normalized = normalizeEmail(email);
	if (!normalized) return false;
	return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(normalized);
}

/** While typing: digits, +, spaces, parentheses, hyphens. */
export function isValidPhoneInput(phone) {
	const value = String(phone ?? "").trim();
	if (!value) return false;
	return /^[\d\s()+\-.]+$/.test(value);
}

/**
 * E.164-style phone for API (e.g. +15555555555).
 * Strips formatting; US 10-digit numbers get +1 prefix.
 */
export function normalizePhone(phone) {
	const trimmed = String(phone ?? "").trim();
	if (!trimmed) return "";

	const digits = trimmed.replace(/\D/g, "");
	if (!digits) return "";

	if (trimmed.startsWith("+")) {
		return `+${digits}`;
	}
	if (digits.length === 10) {
		return `+1${digits}`;
	}
	if (digits.length === 11 && digits.startsWith("1")) {
		return `+${digits}`;
	}
	return `+${digits}`;
}

export function isValidNormalizedPhone(phone) {
	return /^\+[1-9]\d{9,14}$/.test(phone);
}
